export function ScoreArc ({ score }: { score: number }): React.ReactElement {
  const total = 172.8
  const dashOffset = total - (score / 100) * total
  const color = score >= 70 ? 'var(--bp-ok)' : score >= 40 ? 'var(--bp-warning)' : 'var(--bp-critical)'
  return (
    <svg width='140' height='80' viewBox='0 0 140 80'>
      <path d='M15 75 A55 55 0 0 1 125 75' fill='none' stroke='rgba(255,255,255,.08)' strokeWidth='10' strokeLinecap='round' />
      <path
        d='M15 75 A55 55 0 0 1 125 75' fill='none' stroke={color} strokeWidth='10' strokeLinecap='round'
        strokeDasharray={total} strokeDashoffset={dashOffset}
      />
      <text
        x='70' y='68' textAnchor='middle' fontSize='28' fontWeight='800' fill='#F1F4FA'
        fontFamily='var(--bp-font-sans)' letterSpacing='-2'
      >{score}
      </text>
      <text
        x='70' y='80' textAnchor='middle' fontSize='10' fill='var(--bp-panel-ink2)'
        fontFamily='var(--bp-font-sans)'
      >/100点
      </text>
    </svg>
  )
}
